import Link from './Link';

export default Link;


// WEBPACK FOOTER //
// ./src/components/Header/components/Link/index.tsx